import type { BuildingId } from '@/models/types';
import { RAIDS_PER_DAY } from '@/models/constants';

export interface RaidResolution {
  outcome: 'victory' | 'defeat';
  lootGold: number;
  lootFood: number;
}

export interface RaidTarget {
  id: string;
  username: string;
  era: string;
  defensePower: number;
  productionRate: number;
}

export class RaidManager {
  private raidsRemaining: number = RAIDS_PER_DAY;

  getRaidsRemaining(): number {
    return this.raidsRemaining;
  }

  canRaid(): boolean {
    return this.raidsRemaining > 0;
  }

  useRaid(): boolean {
    if (this.raidsRemaining <= 0) return false;
    this.raidsRemaining--;
    return true;
  }

  resetRaids(): void {
    this.raidsRemaining = RAIDS_PER_DAY;
  }

  setRaidsRemaining(n: number): void {
    this.raidsRemaining = n;
  }

  static calculateDefensePower(buildingLevels: Record<BuildingId, number>): number {
    return Object.values(buildingLevels).reduce((sum, lvl) => sum + lvl, 0);
  }

  static resolveRaid(
    troopsInvested: number,
    defenderPower: number,
    defenderProductionRate: number,
  ): RaidResolution {
    if (troopsInvested <= defenderPower) {
      return { outcome: 'defeat', lootGold: 0, lootFood: 0 };
    }

    // Loot = 10-20% of defender's production rate (per hour equivalent)
    const lootMultiplier = 0.1 + Math.random() * 0.1;
    const baseLoot = defenderProductionRate * 3600 * lootMultiplier;
    const lootGold = Math.floor(baseLoot * 0.6);
    const lootFood = Math.floor(baseLoot * 0.4);

    return { outcome: 'victory', lootGold, lootFood };
  }
}
